import { Component } from '@angular/core';
import { KaMaskeComponent } from './ka-maske.component';

/**
 * Maske "Profilkennzeichnung" der KA-Aufnahme: die Felder 60 bis 71 des amtlichen
 * Bogens (Bodensystematische Einheit bis Bemerkungen), in seiner Reihenfolge.
 *
 * Sie tritt bei einem KA-Punkt an die Stelle der SEA-Bodenform: Was dort
 * Hauptbodenform, Feinbodenform und Wasserform sind, ist hier die
 * bodensystematische und die substratsystematische Einheit. Beides steht
 * nebeneinander in DER Datenstruktur, aber nie in einem Punkt - ein Punkt gehört
 * zu genau einem Verfahren.
 *
 * Vorlage gemeinsam mit der Aufnahmesituation (siehe dort).
 */
@Component({
	standalone: false,
	selector: 'bp-ka-profil',
	templateUrl: './ka-felder-maske.component.html',
	styleUrls: ['../../detail/hl-area/hl-area.component.css', './ka-maske.component.css'],
})
export class KaProfilComponent extends KaMaskeComponent {
	protected override get maskeId() { return 'profil' as const; }
}
